// extracted by css-extract-rspack-plugin
export default {"icon":"fk6zU"};